// =============================================================================
// TeamRow.tsx
// Single row of the team-activity bar list. Width animates from 0% to target
// on mount with a per-row delay (cascading wipe).
// =============================================================================

import React, { useEffect, useState } from 'react';

interface TeamRowProps {
  name: string;
  count: number;
  max: number;
  index: number;
}

export function TeamRow({ name, count, max, index }: TeamRowProps) {
  const [mounted, setMounted] = useState(false);
  useEffect(() => { const t = setTimeout(() => setMounted(true), 150 + index * 60); return () => clearTimeout(t); }, [index]);

  const pct = (count / Math.max(max, 1)) * 100;
  return (
    <div style={{
      marginBottom: 6,
      opacity: mounted ? 1 : 0,
      transform: mounted ? 'translateY(0)' : 'translateY(6px)',
      transition: 'opacity 0.4s ease, transform 0.4s ease',
    }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 'var(--m-text-label)', marginBottom: 2 }}>
        <span>{name}</span>
        <span style={{ color: 'var(--text3)' }}>{count}</span>
      </div>
      <div style={{ height: 4, background: 'var(--surface2)', borderRadius: 2 }}>
        <div style={{
          height: '100%',
          width: mounted ? `${pct}%` : '0%',
          background: 'var(--accent)', borderRadius: 2,
          opacity: 0.4 + (count / Math.max(max, 1)) * 0.6,
          transition: 'width 0.8s cubic-bezier(0.34,1.56,0.64,1)',
        }} />
      </div>
    </div>
  );
}
